import React, { FunctionComponent } from "react";
import { BugerlijkeStaatField } from "./types";
import { Rubriek } from "components/aangifte/Rubriek";

export interface Props {
  field: BugerlijkeStaatField;
  level?: number;
}

export const SubCheckboxField: FunctionComponent<Props> = ({ level = 1, field }) => {
  const subCheckboxes = React.useMemo(() => {
    return (
      field.children &&
      field.children.map((child) => <SubCheckboxField key={child.name} field={child} level={level + 1} />)
    );
  }, [field, level]);

  return (
    <Rubriek code={field.name}>
      {({ rubriek, updateValue }) => {
        if (rubriek.disabled) return null;
        return (
          <div className={`sub${level}`}>
            <input
              className={`bs${level}sub`}
              type="checkbox"
              id={field.name}
              name={field.name}
              checked={!!rubriek.value}
              onChange={(e) => updateValue(e.target.checked)}
            />
            <label className="checkboxlabel" htmlFor={field.name}>
              {field.label}
            </label>
            {subCheckboxes}
          </div>
        );
      }}
    </Rubriek>
  );
};

SubCheckboxField.displayName = "SubCheckboxField";
